import { Component, computed, input } from '@angular/core';

import { CbAlertBannerModule } from '@chubb/ui-components';

@Component({
  selector: 'app-rules-error-coverage',
  imports: [CbAlertBannerModule],
  templateUrl: './rules-error-coverage.component.html',
  styleUrl: './rules-error-coverage.component.scss',
})
export class RulesErrorCoverageComponent {
  customerIndex = input.required<number>();
  coverageIndex = input.required<number>();
  errors = input.required<string[]>();
  formattedError = computed(() => {
    return this.errors()
      .filter(
        (message: string, index: number, self: string[]) =>
          index === self.findIndex(messageString => messageString === message),
      )
      .map(str => (str.startsWith('Remove Cover - ') ? str.replace('Remove Cover - ', '').trim() : str));
  });
}
